import { requestApi } from './helper';
import { invalidateDestinationList, invalidateDestination } from './destination';

export const SAVE_ISSUE = 'SAVE_ISSUE';
export const ACK_ISSUE = 'ACK_ISSUE';

export const saveIssue = (issue, dispatch) => {
  dispatch(invalidateDestinationList());

  return { type: SAVE_ISSUE, issue };
};

export const ackIssue = (issue, dispatch) => {
  dispatch(invalidateDestinationList());
  dispatch(invalidateDestination(issue.destinationId));
  return { type: ACK_ISSUE, issue };
};

export const requestSaveIssue = (issue, errorCallback, successCallback) => {
  const requestProperties = {
    method: 'POST',
    headers: {
      'Content-Type': undefined,
    },
    body: issue,
  };

  return requestApi('/issues', requestProperties, saveIssue, errorCallback, successCallback);
};

export const requestAckIssue = (id, errorCallback, successCallback) => {
  const requestProperties = {
    method: 'POST',
  };

  return requestApi(`/issues/${id}/ack`, requestProperties, ackIssue, errorCallback, successCallback);
};



// WEBPACK FOOTER //
// ./src/actions/issue.js